import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Icon,
  ICONS,
  Typography,
  TYPOGRAPHY_SIZE,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';

import { useSetEntriesOrderPriority } from 'src/hooks/gantts-records/set-gantt-record-entries-order.hook';

import { IDayEntriesInfo } from './day-entries-info.interfaces';
import { DayEntryInfoDragRow } from './day-entry-info-drag-row/';
import { HeaderContainer, PopoverInfoWrapper } from './day-entries-info.styles';

const DayEntriesInfo = ({ onClose, actionAllowed, ganttRecordId, entries }: IDayEntriesInfo) => {
  const { t } = useTranslation('gantt');
  const [controlledEntries, setControlledEntries] = useState(entries);
  const setEntriesOrderPriority = useSetEntriesOrderPriority();

  useEffect(() => setControlledEntries(entries), [entries]);

  const moveRow = (dragIndex: any, hoverIndex: any) => {
    const newRecords = [...controlledEntries];
    const element = newRecords.find(item => item.source._id === dragIndex);

    if (!element) return;

    const deleteIdx = newRecords.findIndex(item => item.source._id === dragIndex);
    const replaceIdx = newRecords.findIndex(item => item.source._id === hoverIndex);
    newRecords.splice(deleteIdx, 1);
    newRecords.splice(replaceIdx, 0, element);

    setControlledEntries(newRecords);
  };

  const onEntryDrop = () => {
    const newEntriesOrder = controlledEntries.map(({ _id }: any, index: number) => ({
      entryId: _id,
      orderPriority: index,
    }));

    setEntriesOrderPriority({ variables: { ganttRecordId, newEntriesOrder } });
  };

  return (
    <PopoverInfoWrapper>
      <HeaderContainer>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('labels.timeStripesSorting')}
        </Typography>
        <Icon
          size={22}
          onClick={onClose}
          rightMargin={false}
          icon={ICONS.xCloseIcon}
          color={PLATFORM_THEME_COLORS.grayVariations.murky}
        />
      </HeaderContainer>
      <div>
        {controlledEntries.map((entry: any) => (
          <DayEntryInfoDragRow
            entry={entry}
            key={entry.source._id}
            moveRow={moveRow}
            onEntryDrop={onEntryDrop}
            actionAllowed={actionAllowed}
          />
        ))}
      </div>
    </PopoverInfoWrapper>
  );
};

export default DayEntriesInfo;
